// This is placed here due to error:
// Super expression must either be null or a function when placed
// in Teacher.ts
export var TeacherCurrentView;
(function (TeacherCurrentView) {
    TeacherCurrentView["EXPERT"] = "expert";
    TeacherCurrentView["TEACHER"] = "teacher";
})(TeacherCurrentView || (TeacherCurrentView = {}));
